export default "__VITE_ASSET__9515d54f__"